import React from "react"

export default function Header() {
  return (
    <header className="header">
        <h1 className="header__heading">Virtual lollipop</h1>
        <p className="header__subheading">because we all know someone <br/> who deserves some sugar.</p>
    </header>
  )
}
